import { useEffect, useState } from 'react';
import { Box, Input, Menu, MenuButton, MenuItem, MenuList, Button, Flex, Checkbox } from '@chakra-ui/react';

type SearchableDropdownCheckboxesProps = {
    initialItems: { checked: boolean, name: string }[];
    placeholder: string;
    onSelect: (value: { checked: boolean, name: string }[]) => void;
    isDisabled?: boolean;
};

export const SearchableDropdownCheckboxes = ({
    initialItems,
    placeholder,
    onSelect,
    isDisabled,
}: SearchableDropdownCheckboxesProps) => {
    const [items, setItems] = useState<{ checked: boolean, name: string }[]>(initialItems);
    const [searchTerm, setSearchTerm] = useState('');

    const onSelectItem = (item: { checked: boolean, name: string }) => {
        setItems((prevData) => prevData.map((d) => ({
            name: d.name,
            checked: d.name === item.name ? !item.checked : d.checked,
        })));
        onSelect(items.map((d) => ({
            name: d.name,
            checked: d.name === item.name ? !item.checked : d.checked,
        })));
    };

    const uncheckAll = () => {
        setItems((prevData) => prevData.map((d) => ({
            name: d.name,
            checked: false,
        })));
        onSelect(items.map((d) => ({
            name: d.name,
            checked: false,
        })));
    };

    useEffect(() => {
        setItems(initialItems);
    }, [initialItems]);

    return (
        <Menu closeOnSelect={false}>
            <MenuButton isDisabled={isDisabled} as={Button} width="100%" textAlign="left" px={4} py={2} borderWidth="1px" borderRadius="md">
                {items.filter((item) => item.checked).length || placeholder}
            </MenuButton>
            <MenuList overflowY={'auto'} maxH={'50vh'}>
                <Box px={4} py={2}>
                    <Input
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        mb={2}
                    />
                </Box>
                {items.length > 0 && (
                    <MenuItem onClick={uncheckAll} color="red.500">
                        Clear
                    </MenuItem>
                )}
                {items.map((item, index) => (
                    <MenuItem key={item.name} onClick={() => onSelectItem(item)}>
                        <Flex>
                            <Checkbox isChecked={item.checked}>{item.name}</Checkbox>
                        </Flex>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};
